import { useEffect, useState } from "react";
import { catalogueContentApi } from "../api/services";
import {
  mergeCatalogueContent,
  CATALOGUE_FALLBACKS,
} from "../constants/catalogueDefaults";

export function useCatalogueContent() {
  const [content, setContent] = useState(CATALOGUE_FALLBACKS);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    catalogueContentApi
      .get()
      .then((res) => {
        if (!cancelled) {
          setContent(mergeCatalogueContent(res.data.data.content));
        }
      })
      .catch(() => {
        if (!cancelled) setContent(CATALOGUE_FALLBACKS);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return { content, loading };
}
